import {
  BrickWallIcon,
  HammerIcon,
  HomeIcon,
  LayersIcon,
  TriangleIcon,
} from 'lucide-react'
import type { Service } from '../types'

export const services: Service[] = [
  {
    id: 'remodeling',
    icon: HomeIcon,
    titleKey: 'services.remodeling.title',
    descKey: 'services.remodeling.desc',
  },
  {
    id: 'roofing',
    icon: TriangleIcon,
    titleKey: 'services.roofing.title',
    descKey: 'services.roofing.desc',
  },
  {
    id: 'siding',
    icon: LayersIcon,
    titleKey: 'services.siding.title',
    descKey: 'services.siding.desc',
  },
  {
    id: 'foundation',
    icon: BrickWallIcon,
    titleKey: 'services.foundation.title',
    descKey: 'services.foundation.desc',
  },
  {
    id: 'demolition',
    icon: HammerIcon,
    titleKey: 'services.demolition.title',
    descKey: 'services.demolition.desc',
  },
]
